import gql from '@my/graphql'
import gqlReport from '@/graphql/report'

export default {
  state: {
    sales: {
      docs: [],
      date: {
        initial: '',
        final: ''
      },
      brand: ''
    },
    invoices: {
      docs: [],
      date: {
        initial: '',
        final: ''
      }
    },
    stock: {
      brand: ''
    },
    stockValue: {
      totalProducts: 0,
      totalThree: 0,
      totalWholesaler: 0,
      totalSale: 0,
      totalCost: 0,
      totalsByArticle: [],
      productsWithZeroCost: []
    }
  },

  mutations: {
    setInitialDateReport (state, { report, date }) {
      state[report].date.initial = date
    },
    setFinalDateReport (state, { report, date }) {
      state[report].date.final = date
    },
    setBrand (state, { report, brand }) {
      state[report].brand = brand
    }
  },

  actions: {
    async getDataSales ({ state }) {
      const query = gqlReport.GET_SALES
      const options = { initialDate: state.sales.date.initial, finalDate: state.sales.date.final, brand: state.sales.brand }

      const response = await gql.query(query, options)

      if (!response) return
      if (!response.data || !response.data.getReportSales) return

      state.sales.docs = response.data.getReportSales
    },

    async getStockValue ({ state }) {
      const query = gqlReport.GET_STOCK_VALUE
      const options = { brand: state.stock.brand }

      const response = await gql.query(query, options)

      if (!response) return
      if (!response.data || !response.data.getReportStockValue) return

      const { totalProducts, totalUnit, totalWholesaler, totalSale, totalCost, totalsByArticle, productsWithZeroCost } = response.data.getReportStockValue

      state.stockValue.totalProducts = totalProducts
      state.stockValue.totalUnit = totalUnit
      state.stockValue.totalWholesaler = totalWholesaler
      state.stockValue.totalSale = totalSale
      state.stockValue.totalCost = totalCost
      state.stockValue.totalsByArticle = JSON.parse(totalsByArticle)
      state.stockValue.productsWithZeroCost = productsWithZeroCost || []
    },

    async getDataInvoices ({ state }) {
      const query = gqlReport.GET_INVOICES
      const options = { initialDate: state.invoices.date.initial, finalDate: state.invoices.date.final }

      const response = await gql.query(query, options)

      if (!response) return
      if (!response.data || !response.data.getReportInvoices) return

      state.invoices.docs = response.data.getReportInvoices
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reports.js